import { render, staticRenderFns } from "./LinkInfo.vue?vue&type=template&id=46ceb89d&"
import script from "./LinkInfo.vue?vue&type=script&lang=ts&"
export * from "./LinkInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports